import React, { useEffect } from 'react';
import { SetPageTitle } from '../../utilities/TitleHelper';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ActivityLogGrid from '../../components/activityLog/ActivityLogGrid';


const ActivityLog = props => {

  const { t } = useTranslation();

  useEffect(() => {
    SetPageTitle('Activity log');
  }, [])

  return (
    <>

      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">{t('dashboard:hdgHeading')}</Link></li>            
            <li className="breadcrumb-item active" aria-current="page">{t('activityLog:hdgHeading')}</li>
          </ol>
        </nav>        
        
        <ActivityLogGrid />
      </div>
    </> 
  );
}


export default ActivityLog;